import { render, staticRenderFns } from "./ChameleonGameContainer.vue?vue&type=template&id=185b0092&scoped=true&lang=pug&"
import script from "./ChameleonGameContainer.vue?vue&type=script&lang=js&"
export * from "./ChameleonGameContainer.vue?vue&type=script&lang=js&"
import style0 from "./ChameleonGameContainer.vue?vue&type=style&index=0&id=185b0092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185b0092",
  null
  
)

export default component.exports